import { cx } from 'emotion';
import React, { memo } from 'react';
import { useStyles } from './styles';
import { xss } from './xss';

export interface SlateHtmlProps {
  className?: string;
  html?: string;
}

/**
 * The reason of the component name is since the sources provided by survey config are produced by
 * `Slate`{@link https://github.com/ianstormtaylor/slate}.
 * Provide XSS filter.
 */
function SlateHtml({ className, html }: SlateHtmlProps) {
  const classes = useStyles();
  return (
    <div
      className={cx(classes.slateHtml, className)}
      dangerouslySetInnerHTML={{ __html: xss(html || '') }}
      aria-label="slate html"
    />
  );
}

export default memo(
  SlateHtml,
  (prev, next) => prev.className === next.className && prev.html === next.html
);
